import React from 'react';

interface ProgressBarProps {
  percentage: number;
  size?: 'small' | 'medium';
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percentage,
  size = 'small',
}) => {
  if (percentage === 0) {
    return null;
  }

  const heightClass = size === 'small' ? 'h-1.5' : 'h-2';

  return (
    <div className="flex items-center gap-2">
      <div className={`flex-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden ${heightClass}`}>
        <div
          className="bg-gradient-to-r from-blue-500 to-blue-600 h-full transition-all duration-300"
          style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
        />
      </div>
      <span className="text-[10px] text-gray-600 dark:text-gray-400 font-medium min-w-[32px] text-right">
        {percentage}%
      </span>
    </div>
  );
};
